import Modal from "../modal";

const KvkkModal = ({ isOpen, onClose }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="KVKK Aydınlatma Metni"
    icon="zmdi-info-outline"
    size="large"
  >
    <p>
      Bu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”)
      kapsamında, YÖS DANIŞMANIM tarafından sunulan eğitim ve danışmanlık hizmetleri
      sırasında işlenen kişisel verilerin korunmasına yönelik bilgilendirme amacıyla
      hazırlanmıştır.
    </p>
    <h5>1. Veri Sorumlusu</h5>
    <p>Kişisel verileriniz, veri sorumlusu sıfatıyla YÖS DANIŞMANIM tarafından işlenmektedir.</p>

    <h5>2. İşlenen Kişisel Veriler</h5>
    <p>Hizmetlerimiz kapsamında aşağıdaki veriler işlenebilir:</p>
    <ul>
      <li>Ad, soyad</li>
      <li>Telefon numarası</li>
      <li>E-posta adresi</li>
      <li>Ülke ve şehir bilgisi</li>
      <li>Eğitim talep bilgisi</li>
      <li>Pasaport veya kimlik bilgisi (yalnızca danışmanlık sürecinde gerekli olduğunda)</li>
      <li>IP adresi, cihaz ve tarayıcı bilgileri</li>
      <li>Form doldurma sırasında paylaşılan tüm bilgiler</li>
      <li>Çerez (cookie) verileri</li>
    </ul>

    <h5>3. Kişisel Verilerin İşlenme Amaçları</h5>
    <p>Kişisel verileriniz şu amaçlarla işlenmektedir:</p>
    <ul>
      <li>Yabancı öğrenci danışmanlığı hizmeti sunmak</li>
      <li>TR-YÖS, YÖS ve üniversite başvuru süreçleri hakkında bilgi sağlamak</li>
      <li>Öğrencilerle iletişime geçmek</li>
      <li>Randevu ve başvuru süreçlerini yönetmek</li>
      <li>Sunulan hizmetleri geliştirmek</li>
      <li>Reklam ve pazarlama çalışmaları yürütmek</li>
      <li>Yasal yükümlülükleri yerine getirmek</li>
      <li>Sitedeki kullanıcı deneyimini geliştirmek</li>
    </ul>

    <h5>4. Kişisel Verilerin Aktarılması</h5>
    <p>Kişisel verileriniz aşağıdaki kurum ve kuruluşlara aktarılabilir:</p>
    <ul>
      <li>Hizmet aldığımız yazılım ve altyapı firmaları</li>
      <li>Üniversiteler veya eğitim kurumları (öğrencinin talebi doğrultusunda)</li>
      <li>Yurt içi veya yurtdışı sınav/üniversite başvuru platformları</li>
      <li>Resmi kurumlar (yasal zorunluluk hâlinde)</li>
    </ul>
    <p><strong>Verileriniz hiçbir şekilde üçüncü şahıslara satılmaz.</strong></p>

    <h5>5. Veri Saklama Süresi</h5>
    <p>
      Kişisel verileriniz, hizmetin niteliğine bağlı olarak mevzuatta yer alan süre boyunca
      saklanır; süre sona erdiğinde silinir, anonim hale getirilir veya imha edilir.
    </p>

    <h5>6. KVKK Kapsamındaki Haklarınız</h5>
    <p>KVKK’nın 11. maddesi gereği aşağıdaki haklara sahipsiniz:</p>
    <ul>
      <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
      <li>Yanlış veya eksik işlenen verilerin düzeltilmesini isteme</li>
      <li>Silinmesini talep etme</li>
      <li>İşlemeye itiraz etme</li>
      <li>Aktarıldığı kişi veya kurumları öğrenme</li>
      <li>Zarar görmeniz halinde tazminat talep etme</li>
    </ul>
    <p>Talepleriniz için bizimle iletişime geçebilirsiniz.</p>
  </Modal>
);

export default KvkkModal;

